import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['finance', 'revenue-categories'];

export function useRevenueCategories() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/finance/revenue-categories');
      return data?.categories || data?.data || data || [];
    },
    staleTime: 60_000
  });
}

export function useCreateRevenueCategory() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/finance/revenue-categories', body).then((r) => r.data),
    successMessage: 'تم إنشاء الفئة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useUpdateRevenueCategory() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/finance/revenue-categories/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ الفئة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeleteRevenueCategory() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/finance/revenue-categories/${id}`).then((r) => r.data),
    successMessage: 'تم حذف الفئة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
